'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.TraceLine = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _TraceLine = require('./TraceLine.less');

var _TraceLine2 = _interopRequireDefault(_TraceLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TraceLine = exports.TraceLine = function (_Component) {
	_inherits(TraceLine, _Component);

	function TraceLine() {
		_classCallCheck(this, TraceLine);

		return _possibleConstructorReturn(this, (TraceLine.__proto__ || Object.getPrototypeOf(TraceLine)).apply(this, arguments));
	}

	_createClass(TraceLine, [{
		key: 'render',
		value: function render() {
			return React.createElement(
				'li',
				{ className: _TraceLine2.default.line },
				React.createElement(
					'span',
					{ className: _TraceLine2.default.file },
					this.props.file
				),
				React.createElement(
					'span',
					{
						className: _TraceLine2.default.line },
					this.props.lineNumber ? ' - line ' + this.props.lineNumber + ': ' : ''
				),
				React.createElement(
					'span',
					{ className: _TraceLine2.default.call },
					this.props.call
				)
			);
		}
	}]);

	return TraceLine;
}(_react.Component);


//////////////////
// WEBPACK FOOTER
// ./js/Components/TraceLine.js
// module id = 305
// module chunks = 0